<template>
  <!-- 商品价格区域 -->
  <div class="good-price-area" :style="(customStyle && customStyle.root) || {}">
    <div
      :class="['good-price', customOperator.type === 'large' ? 'large' : '']"
    >
      <!-- 商品单价 -->
      <div
        class="unit-price"
        :style="(customStyle && customStyle.unitPrice) || {}"
      >
        {{ unitPriceText }}
      </div>
      <!-- 商品规格 -->
      <div
        v-if="ssuInfo.ssuFpText"
        :style="(customStyle && customStyle.ssuFpText) || {}"
        class="ssu-fp"
      >
        {{ ssuInfo.ssuFpText }}
      </div>
    </div>

    <template v-if="!showOriginalPrice">
      <div v-if="billionPrice" class="total-price">
        <span class="unit">￥</span>
        <span
          class="price"
          :style="(customStyle && customStyle.billionPrice) || {}"
          >{{ billionPrice }}</span
        >
      </div>
    </template>

    <div v-if="showOriginalPrice" class="billion-price-operator">
      <div v-if="showPriceLine" class="billion-price-wrapper">
        <div class="billion-price-line">
          <span class="origin-price-tip">￥{{ originalPrice }}</span>
          <div class="billion-price">
            <span class="unit">￥</span>
            <span
              class="price"
              :style="(customStyle && customStyle.billionPrice) || {}"
              >{{ billionPrice }}</span
            >
          </div>
        </div>
        <div v-if="billionTip" class="billion-price-tip">
          {{ billionTip }}
        </div>
      </div>
      <div v-else class="total-price sole">
        <span class="unit">￥</span>
        <span
          class="price"
          :style="(customStyle && customStyle.billionPrice) || {}"
          >{{ billionPrice }}</span
        >
      </div>

      <!-- 加购按钮部分 -->
      <div class="operator-wrapper-large">
        <new-operator
          :use-simple="customOperator.simple"
          :use-icon="false"
          :btn-text="'加入购物车'"
          :btn-width="customOperator.btnWith || 1.92"
          :use-arrived-notice-icon="customOperator.simple"
          show-simple-count
          :show-promote-tip="customOperator.showPromoteTip"
          :ssu="ssu"
          :icon-color="customOperator.iconColor"
          :show-can-not-buy="false"
          :bg-start-color="customOperator.bgStartColor"
          :bg-end-color="customOperator.bgEndColor"
          @add="addGoods"
          @subtract="subtractGoods"
          @goDetail="goDetail"
        />
      </div>
    </div>

    <!-- 加购按钮部分 -->
    <div v-else class="operator-wrapper-large">
      <new-operator
        :use-simple="customOperator.simple"
        :use-icon="false"
        :btn-text="'加入购物车'"
        :btn-width="customOperator.btnWith || 1.92"
        :use-arrived-notice-icon="customOperator.simple"
        show-simple-count
        :show-promote-tip="customOperator.showPromoteTip"
        :ssu="ssu"
        :show-can-not-buy="false"
        :bg-start-color="customOperator.bgStartColor"
        :bg-end-color="customOperator.bgEndColor"
        :icon-color="customOperator.iconColor"
        @add="addGoods"
        @subtract="subtractGoods"
        @goDetail="goDetail"
      />
    </div>
  </div>
</template>

<script>
import NewOperator from '@/common/widgets/newOperator/newIndex.vue'
export default {
  components: {
    NewOperator
  },
  props: {
    ssu: {
      type: Object,
      default: () => {}
    },
    ssuInfo: {
      type: Object,
      default: () => {}
    },
    showOriginalPrice: {
      type: Boolean,
      default: false
    },
    showPriceLine: {
      type: Boolean,
      default: false
    },

    customOperator: {
      type: Object,
      default: () => {
        return {
          simple: true,
          showPromoteTip: false,
          type: 'normal',
          canScroll: false
        }
      }
    },
    customStyle: {
      type: Object,
      default: () => {}
    },
    billionTip: {
      type: String,
      default: ''
    }
  },

  computed: {
    // 单价展示处理
    unitPrice() {
      const approximateShow = this.ssuInfo.ssuPrice.isShowWeightUnitPrice === 1
      return {
        prefix: approximateShow ? '约￥' : '￥',
        price: this.ssuInfo.ssuPrice[
          approximateShow ? 'weightUnitPrice' : 'unitPrice'
        ],
        unit: this.ssuInfo.ssuPrice[
          approximateShow ? 'weightPriceUnit' : 'priceUnit'
        ]
      }
    },
    unitPriceText() {
      const unitPrice =
        this.unitPrice.prefix + this.unitPrice.price + '/' + this.unitPrice.unit
      var predict = this.ssuInfo.ssuPrice.predictSsuUnitPriceText
      const predictUnitPrice =
        predict.priceSymbol +
        predict.predictShowPrice +
        predict.predictPriceUnitSuffix
      return this.isPredictPrice ? predictUnitPrice : unitPrice
    },
    isPredictPrice() {
      return this.ssuInfo.ssuPrice.isPredictPrice === 1
    },
    billionPrice() {
      return this.isPredictPrice
        ? this.ssuInfo.ssuPrice?.predictTotalPrice
        : this.ssuInfo.ssuPrice?.totalPrice
    },
    originalPrice() {
      return this.isPredictPrice
        ? this.ssuInfo.ssuPrice?.totalPrice
        : this.ssuInfo.ssuPrice?.originalPrice
    }
  },
  methods: {
    // 统一商品模块埋点上报方法
    tracerReport(type) {
      const tickerInfo = this.ssuInfo.tickerInfo
      this.$track(
        tickerInfo[type].spm,
        Object.assign({}, tickerInfo.data, tickerInfo[type].spmJson)
      )
    },
    // 商品加购处理
    addGoods() {
      // 加购埋点
      this.tracerReport('addcart')
    },
    // 商品减购处理
    subtractGoods() {
      // 减购埋点
      this.tracerReport('subcart')
    },
    goDetail() {
      this.$emit('goDetail')
    }
  }
}
</script>

<style lang="scss" scoped>
.good-price-area {
  .good-price {
    display: flex;

    height: 0.28rem;

    overflow: hidden;
    box-sizing: content-box;

    flex-flow: row wrap;

    justify-content: flex-start;
    align-items: flex-start;
    .unit-price {
      height: 0.28rem;
      @include text(0.2rem, #999);
    }
    .ssu-fp {
      margin-left: 0.08rem;

      padding: 0.02rem 0.08rem;

      background-color: #f5f5f5;

      border-radius: 0.04rem;

      @include text(0.2rem, #262626);
    }
  }
  .total-price {
    margin-top: 0.04rem;
    margin-bottom: 0.06rem;

    color: #ff3400;
    @include flex(row, flex-start, flex-end, nowrap);
    &.sole {
      margin-top: 0.08rem;
    }
    .unit {
      font-size: 0.24rem;
    }
    .price {
      font-size: 0.4rem;
      font-weight: bold;
    }
  }
  .billion-price-operator {
    margin-top: 0.28rem;
    @include flex(row, space-between, center, nowrap);
    .billion-price-wrapper {
      .billion-price-line {
        position: relative;

        width: 3.48rem;
        height: 0.58rem;

        background-image: url('~@/images/cms/goods/price_line.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        .origin-price-tip {
          position: absolute;
          bottom: 0.02rem;
          left: 0.14rem;

          font-size: 0.24rem;
          text-decoration: line-through;
          color: #999;
        }
        .billion-price {
          position: absolute;
          top: -0.2rem;
          right: 0.4rem;

          color: #ff3400;
          .unit {
            font-size: 0.24rem;
          }
          .price {
            font-size: 0.44rem;
            font-weight: bold;
          }
        }
      }
      .billion-price-tip {
        width: 1.68rem;
        height: 0.38rem;
        margin-top: 0.04rem;
        margin-left: 1.64rem;
        padding-top: 0.06rem;

        background-image: url('~@/images/cms/goods/billion_bg.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;

        @include flex-row-center;
        @include text-overflow-ellipsis-single;
        @include text(0.24rem, #fff);
      }
    }
  }
}
</style>
